import { OptionsViewModel, AddressViewModel } from '@models/common.models';
import { DocumentViewModel } from '@models/Document';

export interface CustomerSearchViewModel {
  id: number;
  name: string;
  emailAddress: string;
  phone: string;
  phone2: string;
}

export interface CustomerViewModel {
  id: number;
  name: string;
  accountId?: number;
  company: OptionsViewModel;
  customerType: OptionsViewModel;
  customerStatus: OptionsViewModel;
  language: OptionsViewModel;
  emailAddress: string;
  phone: string;
  phone2?: string;
  phone1Type: OptionsViewModel;
  phone2Type?: OptionsViewModel;
  usps: boolean;
  email: boolean;
  addresses: AddressViewModel[];
  documents: DocumentViewModel[];
  isOlo?: boolean;
}

// setting preset values on new customer
export var initialCustomerVM: Partial<CustomerViewModel> = {
  usps: true,
  customerType: { id: 1, value: 'Personal Customer' },
  customerStatus: { id: 0, value: 'Normal' },
  language: { id: 0, value: 'English' },
  addresses: [] as Array<AddressViewModel>
};

export interface CustomerSearchViewModel {
  id: number;
  name: string;
  emailAddress: string;
  phone: string;
  phone2: string;
}

export class CustomerModel implements CustomerViewModel {
  id: number;
  name: string;
  accountId?: number;
  company: OptionsViewModel;
  customerType: OptionsViewModel;
  customerStatus: OptionsViewModel;
  language: OptionsViewModel;
  emailAddress: string;
  phone: string;
  phone2?: string;
  phone1Type: OptionsViewModel;
  phone2Type?: OptionsViewModel;
  usps: boolean;
  fax: boolean;
  email: boolean;
  addresses: AddressViewModel[];
  documents: DocumentViewModel[];

  constructor(customerData?: CustomerViewModel) {
    this.addresses = customerData ? customerData!.addresses : [];
    this.documents = customerData ? customerData!.documents : [];
  }
}

export interface CustomerContractModel {
  customerId: number;
  contractNum: string;
  relationship: string;
}



// WEBPACK FOOTER //
// ./src/_models/Customer.ts